import axios from "axios";

export default axios.create({
  // baseURL: "http://localhost:9090/",
  //baseURL: "http://62.171.153.83:8080/NutraConnectApi-Web/",
  baseURL:
    "https://api.nutraceutical.digitalnoticeboard.biz/NutraConnectApi-Dev/",
  // baseURL: "http://192.168.1.156:9090/",

  headers: {
    "Content-Type": "application/json",
  },
});
